import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';
const timeUnitMap = {
  MINUTES: 'Minutes',
  DAYS: 'Days',
  WEEKS: 'Weeks',
  MONTHS: 'Months',
  QUARTERS: 'Quarters',
  YEARS: 'Years',
};
export const AtrTrailLine = observer(
  ({
    tradePlanId,
    priceToBreak,
    pctOfAtr,
    candleDuration,
    timeUnit,
    size,
    scaleY,
    portalRef,
  }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
    const paused = tradePlan?.exitTactics['ATR_TRAIL']?.paused ?? null;
    const json = {
      Category: 'Exit Tactic',
      Type: 'ATR Trail',
      'Pct. of ATR': Number(pctOfAtr) * 100 + '%',
      'Trail Price': ApplyRounding(Number(priceToBreak), 2),
      'Candle Duration': candleDuration,
      'Time Unit': timeUnitMap[timeUnit],
    };

    return (
      <>
        {scaleY && priceToBreak > 0 && priceToBreak < 1000000 ? (
          <>
            {paused ? (
              <line
                strokeDasharray={4}
                stroke={colors.red}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreak))}
                y2={scaleY(Number(priceToBreak))}
              />
            ) : (
              <line
                stroke={colors.red}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreak))}
                y2={scaleY(Number(priceToBreak))}
              />
            )}

            <HoverBox
              json={json}
              topBoundary={scaleY(Number(priceToBreak)) - 2}
              bottomBoundary={scaleY(Number(priceToBreak)) + 2}
              leftBoundary={0}
              rightBoundary={size}
              portalRef={portalRef}
              size={size}
            />
          </>
        ) : null}
      </>
    );
  }
);
